/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface IAddFittingPopupFacade {
  sendClosePopupActionForManageMode(mode: boolean): void;
  selectManageMode(): Observable<boolean>;
  InitializeSystemInfo(): void;
  setManageModeAction(value: boolean): void;
  sendClosePopupAction(): void;
}

export const ADD_FITTING_POPUP_FACADE_TOKEN = new InjectionToken<IAddFittingPopupFacade>(
  'ADD_FITTING_POPUP_FACADE_TOKEN'
);
